import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getSuppliers } from './actions';

import SupplierModal from './modal';
import SupplierTable from './table';

class Supplier extends React.Component{
	render(){

		// console.log(this.props);
		const { add, suppliers } = this.props;
		console.log(suppliers);
		return (
			<div>

				{/* modal */}
				<SupplierModal 
					handleCancel={this.toggleAddSupplier}
					visible={add }
				/>

				{/* table */}
				<SupplierTable 
					handleClickAddSupplier={this.toggleAddSupplier} 
					{...suppliers} />
				{/* onClickAddSupplier={} */}

			</div>
		)
	}	

	toggleAddSupplier = () => {

		if(this.props.add){
			this.props.history.push('/supplier');
		} else {
			this.props.history.push('/supplier/add');
		}
		
	}
}

export default connect(
	state => ({
		suppliers: state.suppliers
	}),

	dispatch => ({
		getSuppliers: dispatch(getSuppliers())
	})
)( withRouter(Supplier) );


// WEBPACK FOOTER //
// ./src/components/supplier/index.js